import './AIQuestionNotification.sass';

import { useEffect, useState } from 'react';

import { AI_TASK_STATUS } from '../constants/constants';
import DeleteAIQuestionNotificationModal from './DeleteAIQuestionNotificationModal';

export default function AIQuestionNotification({
  aiQuestionGeneration,
  deleteNotification,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const { status, timeElapsed, id, createdAt } = aiQuestionGeneration;

  // Local visual clock: ticks every second on the client so the counter
  // feels smooth, independent of the 30s backend polling interval
  const [displayedElapsed, setDisplayedElapsed] = useState(timeElapsed);

  // Resync with the backend value whenever a new poll comes in (every 30s),
  // to correct for any client/server drift
  useEffect(() => {
    setDisplayedElapsed(timeElapsed);
  }, [timeElapsed]);

  useEffect(() => {
    if (status !== AI_TASK_STATUS.IN_PROGRESS || !createdAt) return;

    const interval = setInterval(() => {
      setDisplayedElapsed(Math.floor((Date.now() - createdAt) / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, [status, createdAt]);

  const handleToggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  const handleCloseNotification = () => {
    setIsActive(false);
  };

  useEffect(() => {
    if (status !== AI_TASK_STATUS.FINISHED) return;

    const timeout = setTimeout(() => {
      setIsActive(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [status]);

  if (!isActive) return null;

  return (
    <>
      {status === AI_TASK_STATUS.IN_PROGRESS ? (
        <div className="notification--in-progress">
          <span>Creating AI Questions</span>
          <span>Time elapsed: {displayedElapsed} seconds</span>
          <i className="fa fa-times close--icon" onClick={handleToggleModal} />
        </div>
      ) : null}

      {status === AI_TASK_STATUS.FINISHED ? (
        // No close icon here on purpose: this notification must always
        // auto-dismiss after 3 seconds and can't be closed manually
        <div className="notification--finished">
          <span>AI Questions created</span>
          <span>Total time: {timeElapsed} seconds</span>
        </div>
      ) : null}

      {status === AI_TASK_STATUS.FAILED ? (
        <div className="notification--failed">
          <span>AI Questions generation failed</span>
          <span>Total time: {timeElapsed} seconds</span>
          <i className="fa fa-times close--icon" onClick={handleToggleModal} />
        </div>
      ) : null}

      {isOpen ? (
        <DeleteAIQuestionNotificationModal
          isOpen={isOpen}
          toggle={handleToggleModal}
          aiTaskId={id}
          handleCloseNotification={handleCloseNotification}
          deleteNotification={deleteNotification}
        />
      ) : null}
    </>
  );
}
